import MCPPage from "@/components/products/mcp/MCPPage"

type Props = {}

const index = (_props: Props) => {
  return <MCPPage />
}

export default index
